import { render } from "./CallTypePerDayColumnChart.vue?vue&type=template&id=95898a72&ts=true"
import script from "./CallTypePerDayColumnChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallTypePerDayColumnChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallTypePerDayColumnChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95898a72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95898a72', __exports__)) {
    api.reload('95898a72', __exports__)
  }
  
  module.hot.accept("./CallTypePerDayColumnChart.vue?vue&type=template&id=95898a72&ts=true", () => {
    api.rerender('95898a72', render)
  })

}


export default __exports__